/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { MoonLoader } from "react-spinners";
import { GetService, PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import {
  showErrorAlert,
  showSuccessAlert,
} from "../../../../Helper/SweetAlert";
import { Link, useLocation, useParams } from "react-router-dom";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default function PrivacyPolicy() {
  const [DataObj, setDataObj] = useState("");
  const [Content, setContent] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [submitLoader, setsubmitLoader] = useState(false);
  const [Type, setType] = useState("");
  const location = useLocation();
 
  useEffect(() => {
    console.log(location);
    console.log(location.pathname.includes("privacy-policy"));
    if (location.pathname.includes("privacy-policy")) {
      setType("Privacy Policy");
      getDetails("Privacy Policy");
    } else if (location.pathname.includes("terms-condition")) {
      setType("Terms And Condition");
      getDetails("Terms And Condition");
    }
  }, [location]);

  const getDetails = async (type) => {
    setLoading(true);
    GetService(`${API_URL.GET_CONTENT_DETAILS}?type=${type}`).then((res) => {
      console.log(res);
      if (res.data?.status === true) {
        setDataObj(res?.data?.data);
        setContent(res?.data?.data?.content)
        setLoading(false);
      } else {
        showErrorAlert(res.data?.message);
        setLoading(false);
      }
    });
  };

  function submit() {
    if (!Content) {
      setError(true);
      return;
    }
    const data = { content_id: DataObj?.content_id, content: Content };

    setsubmitLoader(true);
    PostService(API_URL.UPDATE_CONTENT, data).then(
      (res) => {
        if (res.data.status === true) {
          setsubmitLoader(false); 
          showSuccessAlert(res?.data?.message);
        } else {
          showErrorAlert(res.data?.message);
        }
      },
      (err) => {
        showErrorAlert(err.data?.message);
      }
    );
  }


  return (
    <div>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h3>{Type}</h3>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <Link
                  to="/panel/dashboard"
                  className="breadcrumb-item"
                  style={{ textDecoration: "none" }}
                >
                  Dashboard
                </Link>
                <Link className="breadcrumb-item active">{Type}</Link>
              </ol>
            </div>
          </div>
        </div>
      </section>

      <div class="card">
        {!loading && (
          <div class="card-body mt-3">
            <div className="row offset-md-1">
              <div className="col-11 form-group">
                <label>Title</label>
                <input
                  type="text"
                  placeholder="Title"
                  className="form-control"
                  value={DataObj?.title}
                  disabled
                />
              </div>

              <div className="col-11 form-group">
                <label>
                Content<sup className="error">*</sup>
                </label>
                <CKEditor
                  editor={ClassicEditor}
                  data={Content}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setContent(data);
                  }}
                />
                {error && !Content && (
                    <div className="error">Content is required</div>
                  )}
              </div>
            </div>
            <div>
              <div className="offset-md-1">
                <button
                  className="btn btn-primary ml-3"
                  onClick={() => submit()}
                >
                  {submitLoader ? (
                    <i className="fas fa-spinner fa-spin"></i>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </div>
          </div>
        )}
        {loading ? (
          <div className="LoaderSpinner">
            <MoonLoader
              color={"#003bff"}
              loading={loading}
              speedMultiplier={0.6}
              size={50}
            />
            <div>Loading... Please wait.</div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
